var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "49px",
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu/on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu/on"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#FFFFFF",
    fillOpacity: 0,
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,25.5 L35,25.5",
    id: "Line",
    stroke: "#C3092F",
    strokeWidth: 3,
    strokeLinecap: "square",
    transform: "translate(25.000000, 25.500000) rotate(-45.000000) translate(-25.000000, -25.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,25.5 L35,25.5",
    id: "Line",
    stroke: "#C3092F",
    strokeWidth: 3,
    strokeLinecap: "square",
    transform: "translate(25.000000, 25.500000) rotate(45.000000) translate(-25.000000, -25.500000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOn);
export default __webpack_public_path__ + "static/media/menu_on.60521e239c179563109f1f64bab52001.svg";
export { ForwardRef as ReactComponent };